import { z } from 'zod';

export const schema = z
  .object({
    startTime: z.string().min(1, 'Start time is required'),
    endTime: z.string().min(1, 'End time is required'),
    coachActivityId: z.string().min(1, 'Activity is required'),
    locations: z
      .array(z.string().min(1, 'Location cannot be empty'))
      .min(1, 'Location is required')
  })
  .refine(
    (data) => {
      const today = new Date().toISOString().split('T')[0];
      const start = new Date(`${today}T${data.startTime}`);
      const end = new Date(`${today}T${data.endTime}`);
      return end > start;
    },
    {
      message: 'End time must be after start time',
      path: ['endTime']
    }
  );
